import { withScope } from '@sentry/react';

type ClientDataErrorPayload = {
  cognitoUsername: string;
  contactId?: string;
  clientId?: string;
  originalErrorMessage?: string;
};

export class ClientDataError extends Error {
  data: ClientDataErrorPayload;

  constructor(message: string, data: ClientDataErrorPayload) {
    super(message);
    this.data = data;
  }
}

export const logClientDataError = (error: unknown) => {
  withScope(scope => {
    if (error instanceof ClientDataError) {
      scope.setTag('category', 'Bad Data');
      scope.setContext('context', error.data);
    }

    scope.captureException(error);
  });
};
